module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/zh-hant_kyushu-e12ebd55cd24568140b54813afaa3813.jpg";